import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {UrlInfoService} from "./services/url-info/url-info.service";
import {McpBeaconService} from "mcp-beacon";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements AfterViewChecked, OnInit {
  title = 'vitality-quote-tool-ui';

  constructor(private urlInfoService: UrlInfoService, private _mcpBeaconService: McpBeaconService) {
  }

  ngOnInit() {
    this.urlInfoService.loadRouting();
    this._mcpBeaconService.getMcpBeacon();
  }

  ngAfterViewChecked() {
    // this is firing continuously causing our analytics to break.
    // if (window['dataLayer']) {
    //   window['dataLayer'].push({'event': 'optimize.activate'});
    // }
  }
}
